import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { injectIntl, intlShape } from 'react-intl';
import Select from 'react-select';
import { injectTopMakesToOptions } from 'shared/components/SearchPanel/transformOptions';
import { sortCollection } from 'shared/helpers/arrays';
import SelectTranslated from '../SelectTranslated/SelectTranslated';
import TransportPanelAddition from '../TransportPanelAddition/TransportPanelAddition';
import TransportNumericOptions from '../TransportNumericOptions/TransportNumericOptions';
import UpdatedSelect from '../../UpdatedSelect/UpdatedSelect';
import ShowFilterButtonLine from '../ShowFilterButtonLine/ShowFilterButtonLine';

import s from './MotoPanel.css';

class MotoPanel extends React.Component {
  static propTypes = {
    selectedActions: PropTypes.shape().isRequired,
    formState: PropTypes.shape().isRequired,
    formVocabulary: PropTypes.shape().isRequired,
    formData: PropTypes.shape().isRequired,
    collapsed: PropTypes.bool.isRequired,
    toggleCollapsed: PropTypes.func.isRequired,
    //
    intl: intlShape.isRequired,
  };

  render() {
    const { formVocabulary, collapsed, formState, formData, selectedActions, intl } = this.props;

    const {
      makes,
      categories,
      engines,
      drives,
      gearboxes,
      types,
      engineOrders,
      tacts,
    } = formVocabulary;
    const { models } = formData;
    const toSort = injectTopMakesToOptions(makes, intl);
    sortCollection(models, 'title');
    sortCollection(categories, 'title');
    const selectedSetActions = selectedActions.set;

    return (
      <div>
        <div className={s.mainform}>
          <div className={s.filterItem}>
            <Select
              placeholder={intl.formatMessage({ id: 'Марка' })}
              instanceId="make-ff"
              name="make"
              options={toSort}
              labelKey="title"
              valueKey="id"
              disabled={!makes || !makes.length}
              onChange={selectedSetActions.make}
              value={formState.make}
              matchPos="start"
            />
          </div>
          <div className={s.filterItem}>
            <UpdatedSelect
              instanceId="model-ff"
              name="model"
              placeholder={intl.formatMessage({ id: 'Модель' })}
              labelKey="title"
              valueKey="id"
              disabled={!models || !models.length}
              options={models && models.map ? models : []}
              onChange={selectedSetActions.model}
              value={formState.model}
              matchPos="start"
            />
          </div>
          <div className={s.filterItem}>
            <SelectTranslated
              instanceId="transportChild-ff"
              name="transportChild"
              placeholder={intl.formatMessage({ id: 'Тип' })}
              labelKey="title"
              valueKey="id"
              options={types && types.map ? types : []}
              disabled={!types || !types.length}
              onChange={selectedSetActions.transportChild}
              value={formState.transportChild}
              matchPos="start"
            />
          </div>

          <TransportNumericOptions selectedActions={selectedActions} formState={formState} />

          <div className={s.filterItem}>
            <SelectTranslated
              placeholder={intl.formatMessage({ id: 'Расположение цилиндров' })}
              instanceId="engineOrder-ff"
              name="engineOrder"
              labelKey="title"
              valueKey="id"
              options={engineOrders && engineOrders.map ? engineOrders : []}
              disabled={!engineOrders || !engineOrders.length}
              onChange={selectedSetActions.engineOrder}
              value={formState.engineOrder}
              matchPos="start"
            />
          </div>
          <div className={s.filterItem}>
            <div className={s.flexContainer}>
              <div className={s.left}>
                <SelectTranslated
                  placeholder={intl.formatMessage({ id: 'Коробка' })}
                  instanceId="gearbox-ff"
                  name="gearboxes"
                  labelKey="title"
                  valueKey="id"
                  options={gearboxes && gearboxes.map ? gearboxes : []}
                  onChange={selectedSetActions.gearbox}
                  value={formState.gearbox}
                  matchPos="start"
                />
              </div>
              <div className={s.right}>
                <SelectTranslated
                  placeholder={intl.formatMessage({ id: 'Привод' })}
                  instanceId="type-ff"
                  name="drives"
                  labelKey="title"
                  valueKey="id"
                  options={drives && drives.map ? drives : []}
                  onChange={selectedSetActions.drive}
                  value={formState.drive}
                  matchPos="start"
                />
              </div>
            </div>
          </div>
          <div className={s.filterItem}>
            <div className={s.flexContainer}>
              <div className={s.left}>
                <Select
                  placeholder={intl.formatMessage({ id: 'К-во тактов' })}
                  instanceId="tacts-ff"
                  name="tacts"
                  labelKey="title"
                  valueKey="id"
                  options={tacts && tacts.map ? tacts : []}
                  disabled={!tacts || !tacts.length}
                  onChange={selectedSetActions.tacts}
                  value={formState.tacts}
                  matchPos="start"
                />
              </div>
              <div className={s.right}>
                <SelectTranslated
                  placeholder={intl.formatMessage({ id: 'двигатель' })}
                  instanceId="engine-ff"
                  name="engine"
                  labelKey="title"
                  valueKey="id"
                  options={engines && engines.map ? engines : []}
                  disabled={!engines || !engines.length}
                  onChange={selectedSetActions.engine}
                  value={formState.engine}
                  matchPos="start"
                />
              </div>
            </div>
          </div>
        </div>
        {!collapsed &&
          <div className={s.dividerWrapper}>
            <ShowFilterButtonLine collapsed={collapsed} handleClick={this.props.toggleCollapsed} />
          </div>}
        {!collapsed &&
          <div className={s.fullForm}>
            <TransportPanelAddition
              formVocabulary={formVocabulary}
              selectedActions={selectedActions}
              formState={formState}
            />
          </div>}
      </div>
    );
  }
}

export default withStyles(s)(injectIntl(MotoPanel));



// WEBPACK FOOTER //
// ./src/desktop/components/SearchPanelV2/MotoPanel/MotoPanel.js